export const GOUSTO_COST = {
  headingLine1: 'How much does Gousto cost?',
  ctaText: 'Get started with 50% off',
}
